import { styled } from 'styled-components';
import { Button } from '@template/components/Button/styles.ts';

export const Wrapper = styled.div`
  ${Button} {
    span {
      color: ${({ theme }) => theme.colors.primary.default};
    }
  }
`;
